export const CONNECTIVE_STATUS_KEY = "Status";
export const CONNECTIVE_PACKAGE_REFERENCE = "PackageExternalReference";
export const DAYS_BEFORE_WARNING = 3;

export enum ConnectiveStatus {
    Signed = "SIGNED",
    Finished = "FINISHED",
    Rejected = "REJECTED",
    Reject = "REJECT",
    InvalidToken = "INVALIDTOKEN",
}

export const CONNECTIVE_SUCCESSFULL_STATUSES = [
    ConnectiveStatus.Signed.valueOf(),
    ConnectiveStatus.Finished.valueOf(),
    ConnectiveStatus.Rejected.valueOf(),
    ConnectiveStatus.Reject.valueOf(),
];
